export default {
  global: {
    home: 'Home',
    login: 'Login',
    submit: 'Submit',
    reset: 'Reset',
    delete: 'Delete',
    clear: 'Clear',
    send: 'Send',
    init: 'Init',
    confirm: 'Confirm',
    min: 'Min',
    max: 'Max',
    confirmDelete: 'Are you sure you want to delete this item?',
    no_result: 'No results',
    no_select: 'No select',
    close: 'Close',
    back: 'Back',
    cancel: 'Cancel',
    update: 'Update',
    relance:'Reorder',
    updated: 'Updated',
    updatedat: 'Updated at',
    closeddat:'Closed at',
    updatedby: 'Updated by',
    view: 'View',
    viewall: 'View all',
    field: 'Field',
    value: 'Value',
    filters: 'Filter',
    data_unavailable: 'Data unavailable',
    loading: 'Loading...',
    deleted: 'Deleted',
    created: 'Created',
    createdat: 'Created at',
    createdby: 'Created by',
    uploaded: 'Uploaded',
    bigger_zero: 'Please, insert a value bigger than zero!',
    type_something: 'Please type something',
    field_required: 'Field is required',
    records_per_page: 'Records per page:',
    actions: 'Actions',
    list: 'List',
    add: 'Add',
    datestart: 'Start date',
    dateend: 'End date',
    name: 'Name',
    fileinput: 'File input',
    credentialerror: 'Credential error',
    sizeerror_100:'The file is to heavy (max value : 100Mo)',
    sizeerror_20:'Le fichier est trop volumineux (maximum 20Mo)',
    type: 'Type',
    date: 'Date',
    dateCreation: 'Creation date',
    dateUpdate: 'Update date',
    true: 'True',
    false: 'False',
    content: 'Content',
    access: 'Access',
    editimage: 'Edit image',
    timeline: 'Timeline',
    validate: 'Validate',
    invalidate: 'Invalidate',
    explore: 'Explore',
    download: 'Download',
    file: 'File',
    addcombo1: 'Press',
    addcombo2: 'to create a new one',
    enable: 'Enable',
    email: 'Email',
    maxsize: 'File too large',
    yes: 'yes',
    no: 'no'
  },
  menu: {
    catalog: 'Catalog',
    printers:   'Printers',
    files:   'Files',
    parameter:   'Parameters',
    designfile:   'Design (STL)',
    prodfile:   'Production (gcode)',
    administration:   'Administration',
    orderactions : 'Actions',
    notification: {
      notifications:   'Notifications',
    },
    language: {
      english:   'English',
      french:   'French',
    },
    user: {
      profile: 'Profile',
      logout: 'Logout',
      notificationsubscriber: 'Notifications',
    },
  },
  printer: {
    printer: 'Printer',
    printers: 'Printers',
    address:   'Ip address',
    machine:   'Machine ref.',
    api:   'Api',
    enabled: 'Enabled',
    toolnodefine: 'Tool no define',
    interfacemachine: 'Machine Interface',
    tags: 'Tags',
    markOk: 'Mark as ready',
    markOut: 'Mark as Out of Order',
    outOfOrder: "Out of Order"
  },
  prodfile: {
    prodfiles:   'Production files',
    prodfile:   'Production file',
    gcode:   'Gcode',
    designfile: 'Design file',
    quantity: 'Quantity',
    timeexecution: 'Time (min)',
    materialconsumed: 'Material consumed (g)',
    add: 'Create Production file',
    comment: 'Comment',    
    layerHeight: 'Layer height'
  },
  designfile: {
    designfiles:   'Design files',
    designfile:   'Design file',
    types: 'Design file types',
    type: 'Type',
    tags: 'Tags',
    production: 'Production',
    ref: 'Reference',
    comment: 'Comment',
    stl: 'Stl',
    catalog: 'Catalog',
    add: 'Add new Conception File',
    customer: 'Customer',
    nda: 'NDA',
    confidential: "Be careful, this file is confidential"
  },
  order: {
    orders:   'Fabrication orders',
    order:   'Fabrication order',
    neworders: 'New fabrication orders',
    myorders: 'My fabrication orders',
    process: 'Order process',
    id:'Order number',
    ref: 'Reference',
    delivery: 'End of production date desired by the client',
    delivery_short: 'Customer’s desired date',
    delivery_interne: 'End date of manufacturing estimated by our teams.',
    delivery_short_interne:'Internal delivery date',
    no_delivery: 'No delivery date yet',
    dateCloture: 'Ending date',
    quantity: 'Quantity expected',
    states:   'Order states',
    state:   'Order state',
    state_: 'State',
    type: 'Order type',
    types: 'Order types',
    type_:'Type',
    end: 'End state',
    cancel: 'Cancel',
    valid: 'Valid',
    init: 'Init',
    orderaction: 'New order',
    echanges:'Exchanges',
    historique:'History',
    timeexecution: 'Print time estimated (min)',
    comment: 'Description',
    fileannexe: 'Annex file',
    request: "Request",
    fabrication: "Fabrication",
    operator: "Operator",
    toDo:'To Do',
    tags: "Tags",
    tag:"Tag",
    verticales:"Verticales",
    verticale:"Verticale",
    sectors:"Sectors",
    sector:"Sector",
    orderactions: 'Actions',
    price: 'Price (€)',
    unitPrice: 'Unit price (€)',
    cost: 'Cost (€)',
    unitCost: 'Unit cost (€)',
    risk: 'Risk level (%)',
    material:'Material',
    claimant: 'Claimant',
    general: 'General',
    currentstatus: 'Current status : ',
    specialDoable: 'Doable',
    specialPrinted: 'Imprimé',
    specialToPrint: 'To Print',
    specialOrdered: 'Ordered by customer',
    couleur_departement: 'Color and department concerned:',
    specialstatus: 'Special status:',
    unstarted: 'Unstarted',
    started: 'Started Orders',
    finished: 'Finished orders',
    erroractionnoorder: 'Order is empty',
    resolution: 'Resolution',
    resolutions: 'Résolutions',
    quotation: 'BC order number',
    quality: 'Quality',
    LabelPrint: "Print",
    failedItems: "Failed items",
    assigned: "Assigned",
    new: "New",
    withoutOperator: "Without Operator"
  },
  comment: {
    FillComment: "Please, fill the comment with the following informations:"
  },
  action_type: {
    auto_create: 'Automatic generation'
  },
  risk: {
    risk: 'Risk level',
    risks: 'Risk levels',
    comment: 'Risk level comment'
  },
  state: {
    fillAttributes: 'Please fill theses fields :',
    change: 'Edit statut',
  },
  orderaction: {
    orderactions: "Actions",
    orderaction: "Action",
    user: "User",
    content: "Comment",
    titre: "Title",
    type: 'Action type',
    comment:'massage',
    types: 'Action types',
    file: 'File',
    order: 'Fabrication order',
    tags: "Tags",
    tag:"Tag",
    date: 'Created on'
  },
  accessory: {
    accessories:   'Accessories',
    accessory:   'Accessory',
  },
  customer: {
    customers:   'Customers',
    customer:   'Customer',
    create: 'Create new client',
  },
  controlunit: {
    controlunits:   'Control units',
    controlunit:   'Control unit',
  },
  industrialcomputer: {
    industrialcomputers:   'Industrial computers',
    industrialcomputer:   'Industrial computer',
  },
  machine: {
    machines:   'Machines',
    machine:   'Machine',
  },
  material: {
    materials:   'Materials',
    material:   'Material',
  },
  nozzle: {
    nozzles:   'Nozzles',
    nozzle:   'Nozzle',
  },
  printingsurface: {
    printingsurfaces:   'Printing surfaces',
    printingsurface:   'Printing surface',
  },
  priority: {
    priorities:   'Priorities',
    priority:   'Priority',
    intensity:   'Intensity',
    init:   'Init',
  },
  sector: {
    sectors : 'Sectors',
    sector : 'Sector',
  },
  tag: {
    tags : 'Tags',
    tag : 'Tag',
  },
  toolhead: {
    toolheads: 'Toolheads',
    toolhead: 'Toolhead',
  },
  tool: {
    tools: 'Tools',
    tool: 'Tool',
    toolheaddef: 'Toolhead def',
  },
  updatedlynxapi: {
    updatedlynxapis: 'Datas update',
    updatedlynxapi: 'Datas update',
    start : 'Start',
    end : 'End',
  },
  verticale: {
    verticales : 'Verticales',
    verticale : 'Verticale',
  },
  administration: {
    administration:   'Administration',
    securityparameter: {
      securityparameters: 'Security parameters',
      securityparameter: 'Security parameter',
      parameter: 'Parameter',
      value: 'Value',
      comment: 'Comment',
      forgot_password_time: 'Forgot password link validation time (minutes)',
      login_failure_max: 'Max number of failed login before blocking an account',
      block_password_time: 'Time (minutes) for blocking an account and Time (minutes) where the number of failed connections is counted for blocking an account',
      block_failure_allTime: 'Allows to block or not without time limit (0 to block with a time limit and 1 to block without time limit)',
      change_password_time: 'Time (days) to force password change',
      old_password_nb: 'Number of password stored to check if the new password is different from the old ones',
      password_size_min: 'Password policy, minimum password length',
      password_number_min: 'Password policy, Minimum number of digits in the password',
      password_lowercase_min: 'Password policy, Minimum number of lowercase characters in the password',
      password_uppercase_min: 'Password policy, Minimum number of uppercase characters in the password',
      password_special_min: 'Password policy, Minimum number of special characters in the password',
      logout_auto_time: 'Time (minutes) before automatic logout',
      backup_auto_time: 'Backup, time (days) between automatic backups',
      backup_server: 'Backup, ftp server address',
      backup_port: 'Backup, ftp server port',
      backup_login: 'Backup, login of the ftp server',
      backup_password: 'Backup, password of the ftp server',
      backup_folder: 'Backup, ftp server folder',
    },
    logs: 'Logs',
    backup: {
      backups: 'Saves',
      backup: 'Save',
      backupmanual: 'Save',
      confirmbackup: 'Are you sure you want to save ?',
      success: 'Success',
      address: 'Address',
      auto: 'Auto',
      size: 'Size (ko)',
      finished: 'Finished',

    },
    user: {
      users:   'Users',
      user:   'User',
      connexion: 'Connexion',
      connected: 'You are connected',
      forgotyourpassword: 'Forgot your password ?',
      passwordturnover: 'Password turnover',
      passwordturnovermessage: 'For security reasons, please change your password.',
      forgotpassword:   'Forgot password',
      forgotpasswords:   'Forgot passwords',
      forgotpasswordmessage: 'Submit a request to reset your password by email',
      initpassword:   'Init password',
      initpasswordmessage:   'Choose your new password.',
      connexionusers:   'User connexions',
      connexionuser:   'User connexion',
      ipadress: 'IP Adress',
      login: 'Login',
      password: 'Password',
      oldpassword: 'Old password',
      plainPassword: 'New password',
      confirmPassword: 'Confirm password',
      sameAsPassword: 'Password confirmation is different from password',
      connexionBtn: 'Connexion',
      updatemypassword: 'Update my password',
      email: 'Email',
      date: 'Date',
      failed: 'Connexion failed',
      name: 'Name',
      surname: 'Surname',
      firstname: 'First name',
      lastname: 'Last name',
      enabled: 'Enabled',
      blocked: 'Blocked',
      create: 'Create',
      supervision: 'Supervision',
      lastlogin: 'Last login',
      passwordrequestedat: 'Last forgot password',
      dateblock: 'Last blocking of the account',
      myprofile:  'My profile',
      createconfirm: 'The user has been successfully registered.',
      passwordtemp: 'Temporary password to send to the user',
      unblockuser: 'Unblock user',
      initpassworduser: 'Init password for user',
      initpasswordconfirm: 'The user password reset has been saved.',

    },
    profil: {
      profil:   'Profil',
      profils:   'Profils',
      profilinterface:   'Interface Profil',
      profilinterfaces:   'Profils interface',
      base:   'Default',
      blocs:   'Blocs',
    },
    access: {
      access_read:   'Access - read',
      connexion_user_read:   'User connexions - read',
      forgot_password_read:   'Forgot passwords - read',
      profil_read:   'Profil - read',
      profil_edit:   'Profil - edit',
      security_parameter_read:   'Security parameter - read',
      security_parameter_edit:   'Security parameter - edit',
      user_read:   'User - read',
      user_edit:   'User - edit',
      user_password_init:   'Init password',
      user_unblock:   'User unblock',
    },
    notification: {
      notification:   'Notification',
      notifications:   'Notifications',
      viewall: 'Mark as read all',
      view: 'Mark as read',
      noview: 'Mark as unread',
    },
  },
  notification: {
    security: {
      newuser:   'A new user has been added : {0}',
      newprofil:   'A new profil has been added : {0}',
    },
    order: {
      neworder:   'A new order has been added : {0}',
      updateorder:   'A order {0} has been updated',
      stateorder:   'A state order {0} has been updated',
      deliveryorder:   'The end date of production for the manufacturing order specified by the client for order {0} has been updated.',
      commercial: 'Assigned as commercial for command {0}',
      operator: 'Assigned as operator for command {0}',
      newaction: "A new action has been posted on order {0}",
      updateaction: "The action {0} was updated on order {1}",
    },
  },
};
